<template>
  <router-link
    :to="route"
    target="_blank"
    class="card"
    style="display: block"
  >
    <header class="card-header">
      <p class="card-header-title">
	<slot name="header"></slot>
      </p>
    </header>
    <div class="card-content has-background-white-bis">
      <slot></slot>
    </div>
    <footer class="card-footer">
      <slot name="footer"></slot>
    </footer>
  </router-link>
</template>

<script>
 export default {
   props: {
     route: {
       type: Object,
       required: true
     }
   }
 }
</script>
